import { buildProps, definePropType } from '@ll-plus/utils'
import type { IconProps } from '@ll-plus/components'

import type { ExtractPropTypes } from 'vue'

import type SecondConfirmation from './second-confirmation.vue'

export const secondConfirmationProps = buildProps({
  open: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '温馨提示'
  },
  message: {
    type: String,
    default: '你有未保存的更改，确定关闭？'
  },
  confirmText: {
    type: String,
    default: '确定'
  },
  cancelText: {
    type: String,
    default: '取消'
  },
  icon: {
    type: definePropType<IconProps>(Object),
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  },
  onConfirm: Function,
  onCancel: Function
} as const)

// props
export type SecondConfirmationProps = ExtractPropTypes<
  typeof secondConfirmationProps
>

// instance
export type SecondConfirmationInstance = InstanceType<typeof SecondConfirmation>
